module.exports = __webpack_public_path__ + "img/kn_nodata.19aabb3a.svg";